import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
export function hasIntegration(config: ResolvedBetterstartConfig, integrationId: string): boolean {
  return config.integrations.installed.includes(integrationId)
}
